/**
 * ****************************************************************************
 * @description     :   Reducer to receive action and change state for holon
 * @created at      :   2023/07/25
 * @created by      :   SonMBG - sonmbg@toploop.co
 * @package         :   dashlite-admin-react
 * @copyright       :   Copyright (c) TOPLOOP
 * @version         :   1.0.0
 * ****************************************************************************
 */
/**
 * import libraries
 */
import Actions from './action';


/**
 * Initial state of app
 */
const initialState = {
    blAccount: {},
    blCompany: {},
    blDepartments: [],
    blPositions: [],
    registerBlAccountError: {},
    loading: {
        
    },
};

/**
 * Reducer to process change data of app
 * -----------------------------------------
 * @author : QuyPN - 2023/07/18 - create
 * @param  : {Object} state - Current sate of app
 * @param  : {Object} action - information of action will process
 * @access : public
 */
export default function userReducer(state = initialState, action) {
    switch (action.type) {     
        case Actions.GET_BL_COMPANY_SUCCESS:
            return {
                ...state,
                blCompany: action.payload
            }     
        case Actions.GET_BL_DEPARTMENT_BY_COMPANY_ID_SUCCESS:
            return {
                ...state,
                blDepartments: action.payload
            }    
        case Actions.GET_BL_POSITION_BY_DEPARTMENT_ID_SUCCESS:
            return {
                ...state,
                blPositions: action.payload
            }
        case Actions.REGISTER_BL_ACCOUNT_SUCCESS:
            return {
                ...state,
                blAccount: action.payload
            }
        case Actions.REGISTER_BL_ACCOUNT_FAILURE:
            return {
                ...state,
                registerBlAccountError: action.payload
            }
        case Actions.CLEAR_BL_DEPARTMENT:
            return {
                ...state,
                blDepartments: []
            }    
        case Actions.CLEAR_BL_POSITION:
            return {
                ...state,
                blPositions: []
            }
        default:
            return state;
    }
}
